import { ApiBase } from "./ApiBase";

export interface LeadItem {
  id: string;
  userId: string;
  name: string;
  leadStatus: string;
  phone: string | null;
  email: string | null;
  userType: string;
  followUpDate: string | null;
  leadSource: string;
  createdAt: string;
  updatedAt: string | null;
}

export interface GetLeadsResponse {
  leads: LeadItem[];
}

class LeadsApi extends ApiBase {
  async getLeads(): Promise<GetLeadsResponse> {
    return this.get<GetLeadsResponse>("/crm/leads");
  }
}

export const leadsApi = new LeadsApi();
